import { StContainer, StAboutWrapContainer, StDropDown } from './AboutWrapper.styles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import React, { useState, ReactNode } from 'react';
import { useRouter } from 'next/router';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, Theme } from '@mui/material/styles';
import CustomTabs from '../../components/shared/Tabs/Tabs';
import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import Dropdown from '../../components/shared/Dropdown/Dropdown';
import { getQuery } from '../../lib/utils/common';

export interface ITabLinkItem {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: {
    link: LinkField;
  };
}

type AboutWrapperProps = {
  tabLinks: Array<ITabLinkItem>;
  activeTab: {
    id: string;
    url: string;
    name: string;
    displayName: string;
    fields: {
      link: LinkField;
    };
  };

  children?: ReactNode;
};
const AboutWrapper: React.FC<AboutWrapperProps> = (props) => {
  const { tabLinks, activeTab } = props;
  const [value, setValue] = useState(() =>
    tabLinks.findIndex(({ fields }) => {
      return fields?.link?.value?.id === activeTab?.fields?.link?.value?.id;
    })
  );
  const theme = useTheme();
  const neutral8 = theme.palette.neutral8.main;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const router = useRouter();
  const { query } = router;

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    const tabItem = tabLinks[newValue];
    router.push(
      {
        pathname: tabItem?.fields?.link?.value?.href as string,
        query: getQuery(query),
      },
      tabItem?.fields?.link?.value?.href as string
    );
  };

  const getLinkFields = () => {
    return tabLinks.map(({ fields }) => {
      return fields?.link;
    });
  };
  const getDropdownOptions = () => {
    const options = tabLinks.map(({ fields }) => {
      return { value: fields?.link?.value?.text as string };
    });
    return options;
  };

  return (
    <StContainer container>
      <StAboutWrapContainer item container direction={'column'}>
        <Grid item sx={{ height: '40px', marginBottom: '1rem' }}>
          {isMobile ? (
            <StDropDown
              item
              sx={{
                margin: '0 2px 0 0',
                display: { sm: 'block', lg: 'none' },
                color: (theme: Theme) => `${theme.palette.neutral8.main}`,
              }}
            >
              <Dropdown
                fullWidth={true}
                labelId="scroll-list-select-label"
                id="scroll-list-select"
                dataTestId="scroll-list-select"
                defaultValue={0}
                type="number"
                value={value}
                onChangeHandler={(e: any) => {
                  const num = Number(e.target.value);
                  handleChange(e, num);
                }}
                options={getDropdownOptions()}
                selectSxProps={{
                  width: '100%',
                  borderRadius: '8px !important',
                  height: '38px',
                  color: (theme: Theme) => `${theme.palette.neutral8.main} !important`,
                  '&.MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: (theme: Theme) => `${theme.palette.neutral8.main} !important`,
                      color: (theme: Theme) => `${theme.palette.neutral8.main} !important`,
                    },
                    '&:hover fieldset': {
                      borderColor: (theme: Theme) => `${theme.palette.neutral8.main} !important`,
                      color: (theme: Theme) => `${theme.palette.neutral8.main} !important`,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: (theme: Theme) => `${theme.palette.neutral8.main} !important`,
                      color: (theme: Theme) => `${theme.palette.neutral8.main} !important`,
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: 0,
                      paddingInline: '14px',
                    },
                  },
                }}
                menuItemSxProps={{
                  whiteSpace: 'normal',
                  color: (theme: Theme) => `${theme.palette.neutral8.main} !important`,
                }}
              />
            </StDropDown>
          ) : (
            <Box
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                width: 'fit-content',
              }}
            >
              <CustomTabs
                value={value}
                onChangeHandler={handleChange}
                variant="scrollable"
                scrollButtons={false}
                ariaLabel="visible arrows tabs"
                tabListOptions={getLinkFields()}
                type="link"
                tabsContainerSxProps={{
                  '& .MuiTabs-indicator': {
                    height: '5px',
                    borderRadius: '8px',
                  },
                }}
                tabSxProps={{
                  fontFamily: 'Proxima Nova',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  fontSize: '16px',
                  lineHeight: '16px',
                  color: `${neutral8} !important`,
                }}
              />
            </Box>
          )}
        </Grid>
        <Grid item container>
          {props.children}
        </Grid>
      </StAboutWrapContainer>
    </StContainer>
  );
};

export default AboutWrapper;
